export default __webpack_public_path__ + "static/effortless-selling-ede1a2b5b3721c5d8c5312ead3813aab.png";